export const navLinks = [
  { label: '分区速览', href: '#districts' },
  { label: '精选频道', href: '#featured' },
  { label: '今日热榜', href: '#hotboard' },
  { label: '子版主页', href: '#subforums' },
  { label: '标签索引', href: '#tags' },
  { label: '最新更新', href: '#latest' },
];

export const heroStats = [
  { value: '8', label: '大分区' },
  { value: '691', label: '频道子版' },
  { value: '12.8万', label: '累计条目' },
  { value: '每小时', label: '更新节奏' },
];

export const heroChips = ['娱乐观察', '网络热点', '消费参考', '生活方式', '科技看点', '财经观察', '城市资讯', '体育快讯'];

export const districts = [
  {
    code: 'ENT',
    name: '娱乐观察',
    desc: '影音现场、片场动向与行业观察，追更不迷路。',
    subs: 132,
    posts: '2.6万',
    hot: true,
  },
  {
    code: 'NET',
    name: '网络热点',
    desc: '全网话题追踪与舆情走向梳理，热榜一条不落。',
    subs: 96,
    posts: '3.1万',
    hot: true,
  },
  {
    code: 'BIZ',
    name: '消费参考',
    desc: '好物比价、口碑汇总与避雷参考，先看再买。',
    subs: 74,
    posts: '1.4万',
    hot: false,
  },
  {
    code: 'LIFE',
    name: '生活方式',
    desc: '居住、美食、旅行与日常灵感，慢一点也好看。',
    subs: 118,
    posts: '1.9万',
    hot: false,
  },
  {
    code: 'TECH',
    name: '科技看点',
    desc: '数码新品、应用评测与趋势速览，硬核也有趣。',
    subs: 68,
    posts: '9.2千',
    hot: false,
  },
  {
    code: 'FIN',
    name: '财经观察',
    desc: '市场脉络、公司动态与解读合集，信息先整理。',
    subs: 55,
    posts: '7.8千',
    hot: false,
  },
  {
    code: 'CITY',
    name: '城市资讯',
    desc: '各地新鲜事与本地生活索引，去哪都顺手。',
    subs: 87,
    posts: '1.2万',
    hot: false,
  },
  {
    code: 'SPO',
    name: '体育快讯',
    desc: '赛场战报、转会消息与数据盘点，一场别漏。',
    subs: 61,
    posts: '8.6千',
    hot: false,
  },
];

export const featuredChannels = [
  {
    id: 'feat-1',
    name: '娱乐观察',
    tagline: '片场直击 · 幕后花絮 · 行业风向',
    meta: '132 个子版 · 今日更新 218 条',
    cover:
      'https://readdy.ai/api/search-image?query=dramatic%20film%20set%20spotlights%20and%20camera%20silhouette%20in%20warm%20amber%20and%20deep%20crimson%20tones%2C%20stylized%20editorial%20stage%20photography%20with%20soft%20haze%2C%20clean%20dark%20minimal%20background%2C%20high%20contrast%2C%20no%20faces%2C%20no%20text%2C%20harmonious%20composition&width=900&height=700&seq=hlws-feat-ent-01&orientation=landscape',
    big: true,
  },
  {
    id: 'feat-2',
    name: '网络热点',
    tagline: '话题榜 · 舆情脉络',
    meta: '96 个子版 · 更新 164 条',
    cover:
      'https://readdy.ai/api/search-image?query=glowing%20smartphone%20screen%20on%20a%20dark%20desk%20with%20warm%20crimson%20and%20amber%20ambient%20light%2C%20abstract%20minimal%20technology%20editorial%20photography%2C%20clean%20simple%20background%2C%20soft%20gradient%20glow%2C%20no%20text%2C%20no%20faces&width=900&height=700&seq=hlws-feat-net-02&orientation=landscape',
  },
  {
    id: 'feat-3',
    name: '生活方式',
    tagline: '居住 · 美食 · 旅行',
    meta: '118 个子版 · 更新 132 条',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20minimal%20home%20corner%20with%20warm%20lamp%20light%2C%20latte%20cup%20and%20open%20notebook%20on%20a%20wooden%20table%2C%20soft%20amber%20and%20cream%20tones%2C%20clean%20simple%20background%2C%20editorial%20lifestyle%20photography%2C%20no%20text%2C%20no%20faces&width=900&height=700&seq=hlws-feat-life-03&orientation=landscape',
  },
  {
    id: 'feat-4',
    name: '科技看点',
    tagline: '新机速览 · 评测',
    meta: '68 个子版 · 更新 96 条',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20circuit%20board%20macro%20texture%20with%20warm%20amber%20highlights%20on%20a%20dark%20surface%2C%20minimal%20technology%20editorial%20photography%2C%20clean%20simple%20background%2C%20sharp%20detail%2C%20no%20text%2C%20no%20faces&width=900&height=700&seq=hlws-feat-tech-04&orientation=landscape',
  },
  {
    id: 'feat-5',
    name: '财经观察',
    tagline: '盘面笔记 · 行业信号',
    meta: '55 个子版 · 更新 74 条',
    cover:
      'https://readdy.ai/api/search-image?query=stacked%20coins%20and%20a%20rising%20bar%20chart%20abstract%20composition%20in%20warm%20amber%20and%20crimson%20tones%2C%20minimal%20finance%20editorial%20photography%2C%20clean%20dark%20simple%20background%2C%20soft%20lighting%2C%20no%20text%2C%20no%20faces&width=900&height=700&seq=hlws-feat-fin-05&orientation=landscape',
  },
];

export const hotBoard = [
  { rank: 1, title: '本周热议合集：片场路透与定档消息一次整理', district: '娱乐观察', heat: '9.8万' },
  { rank: 2, title: '话题追踪：社交平台本周关键词变化一览', district: '网络热点', heat: '8.4万' },
  { rank: 3, title: '消费参考：夏季家电选购的避雷清单', district: '消费参考', heat: '6.9万' },
  { rank: 4, title: '城市夜游地图：六个值得慢慢走的街区', district: '城市资讯', heat: '5.7万' },
  { rank: 5, title: '数码新品速览：本月值得关注的五款设备', district: '科技看点', heat: '4.8万' },
  { rank: 6, title: '财报季观察：三个行业释放的关键信号', district: '财经观察', heat: '4.1万' },
  { rank: 7, title: '赛事复盘：周末三场焦点战的数据盘点', district: '体育快讯', heat: '3.6万' },
  { rank: 8, title: '居家改造：小户型收纳的十个可行思路', district: '生活方式', heat: '3.2万' },
  { rank: 9, title: '出行提示：假期热门目的地的人流预测', district: '城市资讯', heat: '2.9万' },
  { rank: 10, title: '口碑两极化：新一季节目开播三日讨论盘点', district: '娱乐观察', heat: '2.5万' },
];

export const hotBoardStats = [
  { label: '今日上榜', value: '120' },
  { label: '新增讨论', value: '8.4k' },
  { label: '活跃分区', value: '8' },
];

export const subForums = [
  { name: '片场速递', parent: '娱乐观察', icon: 'ri-clapperboard-line', count: 42 },
  { name: '播出日历', parent: '娱乐观察', icon: 'ri-calendar-event-line', count: 28 },
  { name: '话题榜', parent: '网络热点', icon: 'ri-fire-line', count: 36 },
  { name: '比价台', parent: '消费参考', icon: 'ri-price-tag-3-line', count: 24 },
  { name: '城市漫游', parent: '生活方式', icon: 'ri-road-map-line', count: 33 },
  { name: '新机速览', parent: '科技看点', icon: 'ri-device-line', count: 19 },
  { name: '盘面笔记', parent: '财经观察', icon: 'ri-line-chart-line', count: 21 },
  { name: '同城新鲜事', parent: '城市资讯', icon: 'ri-building-2-line', count: 47 },
];

export const tags = [
  '片场路透',
  '定档',
  '新番',
  '家电',
  '比价',
  '城市漫步',
  '探店',
  '数码新品',
  '评测',
  '财报',
  '市场观察',
  '赛事复盘',
  '收纳',
  '出行',
  '话题榜',
  '口碑',
  '避雷',
  '幕后花絮',
  '旅行灵感',
  '本地生活',
];

export const latestFeed = [
  {
    id: 'latest-1',
    title: '从片场到定档：一条时间线看懂本周娱乐动向',
    district: '娱乐观察',
    time: '12 分钟前',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20amber%20spotlight%20on%20an%20empty%20stage%20with%20drapes%20in%20deep%20crimson%20tones%2C%20stylized%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20soft%20haze%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hlws-latest-01&orientation=landscape',
  },
  {
    id: 'latest-2',
    title: '关键词在变：社交平台这周都在聊什么',
    district: '网络热点',
    time: '38 分钟前',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20floating%20chat%20bubble%20shapes%20in%20warm%20crimson%20and%20amber%20gradients%20on%20a%20dark%20clean%20background%2C%20minimal%20technology%20editorial%20photography%2C%20soft%20glow%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hlws-latest-02&orientation=landscape',
  },
  {
    id: 'latest-3',
    title: '冰箱洗衣机怎么挑？三条实用避雷建议',
    district: '消费参考',
    time: '1 小时前',
    cover:
      'https://readdy.ai/api/search-image?query=minimal%20kitchen%20appliance%20corner%20with%20warm%20cream%20background%20and%20soft%20amber%20light%2C%20clean%20product%20editorial%20photography%2C%20simple%20tidy%20composition%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hlws-latest-03&orientation=landscape',
  },
  {
    id: 'latest-4',
    title: '一条街逛到底：老城区的慢行路线整理',
    district: '生活方式',
    time: '2 小时前',
    cover:
      'https://readdy.ai/api/search-image?query=quiet%20old%20town%20street%20at%20golden%20hour%20with%20warm%20amber%20light%20and%20long%20shadows%2C%20stylized%20travel%20editorial%20photography%2C%20clean%20simple%20composition%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hlws-latest-04&orientation=landscape',
  },
  {
    id: 'latest-5',
    title: '本月新设备上手：这几点最值得留意',
    district: '科技看点',
    time: '3 小时前',
    cover:
      'https://readdy.ai/api/search-image?query=minimal%20desk%20setup%20with%20a%20blank%20device%20screen%20and%20warm%20amber%20rim%20lighting%20on%20a%20dark%20clean%20surface%2C%20technology%20editorial%20photography%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hlws-latest-05&orientation=landscape',
  },
  {
    id: 'latest-6',
    title: '数据复盘：三场焦点战的关键回合拆解',
    district: '体育快讯',
    time: '4 小时前',
    cover:
      'https://readdy.ai/api/search-image?query=curved%20running%20track%20lanes%20with%20warm%20light%20and%20soft%20shadows%2C%20stylized%20sports%20editorial%20photography%2C%20clean%20minimal%20background%2C%20dynamic%20composition%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hlws-latest-06&orientation=landscape',
  },
];

export const guideSteps = [
  {
    step: '01',
    title: '先看分区',
    desc: '八个大分区按主题划分，从「分区速览」一眼看清规模与热度。',
    icon: 'ri-layout-grid-line',
  },
  {
    step: '02',
    title: '再挑频道',
    desc: '进入精选频道，卡片上标好了子版数量与今日更新量，按需收藏。',
    icon: 'ri-list-check-2',
  },
  {
    step: '03',
    title: '直达子版主页',
    desc: '子版主页入口集中在一处，想逛哪个版块直接点，不用来回找。',
    icon: 'ri-links-line',
  },
];

export const footerColumns = [
  {
    title: '热门分区',
    items: ['娱乐观察', '网络热点', '消费参考', '生活方式'],
  },
  {
    title: '频道入口',
    items: ['片场速递', '播出日历', '话题榜', '比价台'],
  },
  {
    title: '关于本站',
    items: ['站点说明', '内容索引', '使用指引', '更新节奏'],
  },
];